import { render, staticRenderFns } from "./CurrentActivity.vue?vue&type=template&id=37c12914&scoped=true&"
import script from "./CurrentActivity.vue?vue&type=script&lang=js&"
export * from "./CurrentActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c12914",
  null
  
)

export default component.exports